import VMasker from 'vanilla-masker';
import Flash from './flash';
import Axios from 'axios';
import serialize from 'form-serialize';

const phoneMask = '(999) 999-9999';

//VMasker(document.querySelectorAll('.phone-us')).maskPattern(phoneMask);

// Save and continue later
$('#save-continue-later').on('click', function (event) {
  event.preventDefault();
  const form = serialize(document.getElementById('step-1-form'), { hash: true });

  Axios.post('/registration/step-1', form)
       .then(response => {
         Flash.notice('Save successful!');
       })
       .catch(error => {
         Flash.alert('There was an error saving');
       });
});



// WEBPACK FOOTER //
// ./lib/assets/js/registration-step-1.js